export default "__VITE_ASSET__CA$fBvt2__"